import { render, staticRenderFns } from "./MitManagePeopleList.vue?vue&type=template&id=44a882df&scoped=true"
import script from "./MitManagePeopleList.vue?vue&type=script&lang=js"
export * from "./MitManagePeopleList.vue?vue&type=script&lang=js"
import style0 from "./MitManagePeopleList.vue?vue&type=style&index=0&id=44a882df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a882df",
  null
  
)

export default component.exports